import { useEffect, useRef, useState } from 'react';
import type { OnUnavailable, SearchDown } from './CompanySearch';

export default function useCompanySearchAvailability() {
  const [down, setDown] = useState<SearchDown | null>(null);
  const typedFieldRef = useRef<HTMLInputElement>(null);
  const focusTypedField = useRef(false);

  const onUnavailable: OnUnavailable = (kind, hadFocus) => {
    focusTypedField.current = hadFocus;
    setDown(kind);
  };

  useEffect(() => {
    if (!focusTypedField.current) return;
    focusTypedField.current = false;
    typedFieldRef.current?.focus();
  }, [down]);

  return { down, onUnavailable, typedFieldRef };
}
